"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var delay = function delay() {
  var ms = arguments.length <= 0 || arguments[0] === undefined ? 1000 : arguments[0];

  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

exports.default = delay;